import { Mic, MapPin, User, Home } from "lucide-react";

export const useDeliveryUI = ({ orderDetails }) => {
  const iconMap = {
    home: <Home size={18} />,
    user: <User size={18} />,
    location: <MapPin size={18} />,
    mic: <Mic size={18} />,
  };

  const deliveryDetails = {
    header: {
      icon: "home",
      title: " Your Delivery details",
      subtitle: "Details of your current order",
    },
     sections: [
      {
        id: "location",
        icon: "location",
        title: orderDetails?.customer_name,
        description: orderDetails?.customer_address,
      },
    ],
  };

  return {
    iconMap,
    deliveryDetails,
  };
};
